module.exports = __webpack_public_path__ + "img/icn_download.50089546.svg";